export const buildPromoStoreBrandingSyncPayload = (store = {}) => ({
  shopLogoUrl: store?.ShopLogoUrl ?? store?.shopLogoUrl ?? "",
  homepageBannerUrl: store?.HomepageBannerUrl ?? store?.homepageBannerUrl ?? "",
});
